<div class="form-group row mb-{{ formMargin }}">
  <app-custom-form-label
    [label]="label"
    [required]="required"
    [toolTip]="tooltipText"
    [showInfoAsTooltip]="showInfoAsTooltip"
    class="col-md-{{ labelSize }} col-xs-12 weight-600 {{
      showInfoAsTooltip ? 'mt-2' : 'mt-0'
    }} {{ +labelSize === 12 && +inputSize === 12 ? 'mb-1' : 'mb-0' }}"
  >
  </app-custom-form-label>
  <div
    class="col-md-{{ 12 - inputSize - labelSize }}"
    *ngIf="12 - inputSize - labelSize > 0"
  ></div>
  <div class="col-md-{{ inputSize }} col-xs-12">
    <textarea
      [fieldSize]="fieldSize"
      nbInput
      fullWidth
      [name]="fieldName"
      [formControl]="customFormControl"
      [class]="inputClass"
      [placeholder]="placeholder"
      [pattern]="patternMatch"
      [required]="required"
      [minlength]="minlength"
      [maxlength]="maxlength"
      [status]="
        customFormControl?.dirty
          ? customFormControl?.invalid
            ? 'danger'
            : 'success'
          : 'basic'
      "
      [rows]="rows"
      (ngModelChange)="onChangeInputVal($event)"
    ></textarea>
    <div class="mt-2" *ngIf="disabledMsg?.length">
      <p class="caption status-danger mb-0">
        {{ disabledMsg }}
      </p>
    </div>
    <div
      class="mt-2"
      *ngIf="
        customFormControl?.invalid &&
        (customFormControl?.touched || customFormControl?.dirty)
      "
    >
      <p
        class="caption status-danger mb-0"
        *ngIf="customFormControl?.errors?.required"
      >
        {{ missingMsg }}
      </p>
      <p
        class="caption status-danger mb-0"
        *ngIf="customFormControl?.errors?.pattern"
      >
        {{ invalidPatternMsg }}
      </p>
      <p
        class="caption status-danger mb-0"
        *ngIf="
          customFormControl?.errors?.maxlength ||
          customFormControl?.errors?.minlength
        "
      >
        {{ invalidLengthMsg }}
      </p>
      <p
        class="caption status-danger mb-0"
        *ngIf="customFormControl?.errors?.compareField"
      >
        {{ compareFieldErrMsg }}
      </p>
    </div>
    <!-- This section is to show extra information related to input control -->
    <div class="mt-2">
      <ng-content></ng-content>
    </div>
  </div>
</div>
<hr *ngIf="showFormDivider" />
